/******************
	* This is an extremely simple helper method that checks if a target element is a child of some selector
	* Its useful when doing click events on the document to close a modal or something similar
	* If the target isChild, then the user clicked inside the modal, meaning you wouldn't want to close it
	* If the target !isChild, then the user clicked somewhere outside the modal, so you would want to close it
	* Usage Example:
		document.addEventListener('click', function(e) {
			if (!blue.util.isChild(e, '.modal')) {
				modal.close()
			}
		})
******************/
import { util } from '~/core';
export default function isChild(target, test) {
	if (typeof test == 'string') {
		return !!target.closest(test)
	}
	return test.contains(target)
}

util.isChild = isChild